import { useState, useContext, useRef } from 'react';

import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

import authAxios from '../../components/authAxios';
import {UserContext} from "../../App"

import { TextField, Autocomplete } from "@mui/material";
import {Button} from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

// import { Modal, Select } from 'antd';
import { Select, Modal, Divider, message } from 'antd';
import {Button as AntButton} from 'antd';
import { PlusOutlined, PlusCircleOutlined } from '@ant-design/icons';
import NumberFormat from "react-number-format";

import './Loans.css'

// const ApplicationGuarantors = ({ addGtrLine, isModalOpen, setIsModalOpen, gtrLines }) => {

const ApplicationGuarantors = ({ addGuarantor, isModalOpen, setIsModalOpen, tableData }) => {
    const { pageSize } = useContext(UserContext);
    const validDataRef = useRef(false);
    const queryClient = useQueryClient();

    const [amount, setAmount] = useState();
    const [subTotal, setSubTotal] = useState();
    const [amountError, setAmountError]=useState(false)

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const { data: guarantors = [] } = useQuery({
        queryKey: ['guarantors'],
        queryFn: async () => {
          const response = await authAxios.get(`/loans/guarantors/?page_size=${pageSize}`);
          return response.data.results;
        },
    });

    const [guarantorId, setGuarantorId] = useState();
    const guarantor = guarantors.find((g) => g.id === guarantorId);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [idNumber, setIdNumber] = useState('');
    const [contactType, setContactType] = useState('10'); // Default to "Individual"

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [isCreateOpen, setIsCreateOpen] = useState(false);

    const [mode, setMode] = useState('select');   // 'select' | 'create'
    const category = "GUARANTOR"
    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');

    const { mutate: createGuarantor, isLoading: isSaving } = useMutation({
        mutationFn: async () => {
            const response = await authAxios.post('/contacts/', {
                client,
                type: contactType,
                name,
                telephone: mobile,
                email,
                id_number: idNumber,
                category,
                user
            },
            {headers: {
                'Content-Type': 'multipart/form-data'
            }}
        
        );
            return response.data;
        },

        onSuccess: async (created) => {
            await queryClient.invalidateQueries({ queryKey: ['guarantors'] });
            const updatedGuarantors = queryClient.getQueryData(['guarantors']) ?? [];
            const newGuarantor = updatedGuarantors.find((g) => g.contact === created.id);
            setGuarantorId(newGuarantor?.id);
            // console.log('New guarantor:', newGuarantor);
            // if (match) {
            //     setGuarantorId(match.id);
            // } else {
            //     message.warning('Guarantor saved — please select them from the list.');
            // }

            setName(''); setMobile(''); setEmail(''); setIdNumber('');
            setMode('select');
        },
        onError: () => {
            message.error('Could not save guarantor. Please try again.');
        },
    });


    const handleSubmit = (e) => {
        e.preventDefault();
        validDataRef.current=true    

        const newRowData = {
            id: guarantor.id,
            name:guarantor.name,
            phone:guarantor.telephone,
            amount:amount,
        };

        addGuarantor(newRowData);
        setIsModalOpen(false);
    };

    return (
        <>

        <div className="product-details-container application-guarantor-container">
            <table className="styled-table">
                <thead>
                    <tr >
                        <th>#</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Amount</th>
                        <th></th>
                    </tr>
                </thead>
                {tableData && tableData.map((rowData, index) => (
                    <tbody key={index}>
                        <tr>
                            <td>{rowData.id}</td>
                            <td>{rowData.name}</td>
                            <td>{rowData.phone}</td>
                            <td>{Number(rowData.amount).toLocaleString()}</td>
                            <td>
                                <IconButton 
                                    size="small">
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </td>
                        </tr>
                    </tbody>
                ))}
            </table>
        </div>

        <div className="AddRow">
            <Button
                id="AddRowButton"
                onClick={() => {
                    setIsModalOpen(true)}
                }
                variant="outlined" 
                size="small"
                startIcon={<AddCircleOutlineIcon />}
            >
                Guarantor
            </Button>
        </div>
 

        <Modal
            className="dashboard-modal"
            title={mode === 'select' ? 'Add Guarantor' : 'New Guarantor'}
            visible={isModalOpen}
            onCancel={handleCancel}
            footer={
                mode === 'select' ? (
                    <>
                        <AntButton onClick={handleCancel}>Cancel</AntButton>
                        <AntButton type="primary" onClick={handleSubmit}>OK</AntButton>
                    </>
                ) : (
                    <>
                        <AntButton onClick={() => setMode('select')}>Back</AntButton>
                        <AntButton type="primary" loading={isSaving} onClick={() => createGuarantor()}>Save</AntButton>
                    </>
                )
            }
        >

            <div className="dashboard-form">
                {/* Select mode */}
                <div style={{ display: mode === 'select' ? 'block' : 'none' }}>
                    <Select
                        showSearch
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Guarantor"
                        value={guarantorId}
                        onChange={setGuarantorId}
                        optionFilterProp="label"
                        options={guarantors.map((g) => ({ value: g.id, label: g.name }))}
                        dropdownRender={(menu) => (
                            <>
                                {menu}
                                <Divider style={{ margin: '8px 0' }} />
                                <AntButton
                                    type="text"
                                    // icon={<PlusOutlined />}
                                    // style={{ width: '100%', textAlign: 'left' }}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => setMode('create')}
                                    style={{
                                        width: '100%',
                                        textAlign: 'left',
                                        padding: '5px 12px',
                                        height: 'auto',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        margin: '4px 0',
                                        color: '#1890ff'
                                    }}
                                >
                                    <PlusCircleOutlined style={{ fontSize: 16 }} />
                                    {/* New Guarantor */}
                                    <span style={{ marginLeft: 0 }}>New Guarantor</span>
                                </AntButton>
                            </>
                        )}
                    />

                    <TextField
                        className="custom-input"
                        value={guarantor?.telephone ?? ''}
                        label="Telephone"
                        variant="outlined"
                        fullWidth
                        disabled
                    />

                    <NumberFormat
                        value={amount}
                        onValueChange={({ floatValue }) => setAmount(floatValue ?? '')}
                        className="custom-input"
                        fullWidth
                        label="Amount"
                        variant="outlined"
                        customInput={TextField}
                        thousandSeparator
                    />
                </div>
            </div>
  

            <div className="dashboard-form" style={{ display: mode === 'create' ? 'block' : 'none' }}>
                <TextField className="custom-input"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    label="Name" 
                    variant="outlined" 
                    fullWidth
                    required
                />

                <NumberFormat 
                    value={mobile}
                    // onChange={(e) => setMobile(e.target.value.replace(/[()" "]/g,""))}
                    onValueChange={({ value }) => setMobile(value)}   // "254712345678"
                    className="custom-input"
                    fullWidth
                    label="Telephone" 
                    variant="outlined" 
                    customInput={TextField}
                    format="### (###) ######" mask="_"
                />
                <TextField className="custom-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    label="Email" 
                    variant="outlined" 
                    fullWidth
                />
                <TextField className="custom-input"
                    value={idNumber}
                    onChange={(e) => setIdNumber(e.target.value)}
                    label="ID/Passport Number" 
                    // helperText="Maximum number of characters is 9" 
                    variant="outlined" 
                    fullWidth
                    required
                /> 
            </div>
        </Modal>

        </>

    );
};

export default ApplicationGuarantors;
